import styled from 'styled-components'

export const Content = styled.div`
  margin: 1rem 0.5rem;
  max-width: 10rem;
  min-width: 8rem;
`
